export const Editor = {
  Write: 'Editor',
  Preview: 'Náhľad',
  UploadingImage: 'Nahrávanie obrázku',
  PasteDropSelect: 'Pripojte súbory pretiahnutím, výberom alebo kopírovaním a vložením.',
};
